import { Component, Input } from '@angular/core';
import { SmartTableHeaderAndData } from 'src/app/shared/components/smart-table/smart-table.component';

@Component({
    standalone: false,
    selector: 'app-smart-assistant-validation-table',
    templateUrl: './smart-assistant-validation-table.component.html'
})
export class SmartAssistantValidationTableComponent {
    @Input() tableData: SmartTableHeaderAndData = { headers: [], rows: [] };
}
